import ShipperGoodsForm from "./ShipperGoodsForm";

export default ShipperGoodsForm;
